module.exports = __webpack_public_path__ + "static/media/quick-session.973dc053.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/play-screen-icons/quick-session.svg
// module id = 1163
// module chunks = 0